module.exports = __webpack_public_path__ + "static/img/pay_icon2.cc80dcd1.png";